<div class="spinner-overlay">
    <div class="spinner-border text-primary" role="status"></div>
    <div class="spinner-body">
      <h2 class="spinner-message">{{'APP.LOADING' | translate}}</h2>
    </div>
  </div>
  
  <div class="spinner-overlay-backdrop show"></div>